module.exports = "pegasus_template/assets/email1-twitter-icon.png";